import i18n from "src/app/services/i18n";
import { API_KEYS_ROUTE, DEVICE_ACTIVATE_ROUTE, DEVICE_ROUTE, RECORDING_EXTENSION_ROUTE, RESELLER_CUSTOMERS_BILLING_HISTORY_ROUTE, RESELLER_CUSTOMERS_ROUTE, RESELLER_CUSTOMERS_SETTINGS_GUIDE_3CX_ROUTE, RESELLER_CUSTOMERS_SETTINGS_GUIDE_ROUTE, RESELLER_CUSTOMERS_SETTINGS_ROUTE, RESELLER_INVITE_ROUTE, SETTINGS_GUIDE_3CX_ROUTE, SETTINGS_ROUTE, PBX_ROUTE, } from "src/app/router/config";
import DynamicResellerCustomerBreadcrumb from "src/features/breadcrumbs/DynamicResellerCustomerBreadcrumb";
export const pageRoutes = [
    { path: PBX_ROUTE, get breadcrumb() { return i18n.t('PBX.setup_'); } },
    { path: SETTINGS_GUIDE_3CX_ROUTE, get breadcrumb() { return i18n.t('Guide.-.3CX_'); } },
    { path: API_KEYS_ROUTE, get breadcrumb() { return i18n.t('API.keys_'); } },
    { path: '/conversations/:id', get breadcrumb() { return i18n.t('Conversation.Details_'); } },
    { path: '/settings/teams', get breadcrumb() { return i18n.t('Teams.and.Members_'); } },
    { path: '/settings/members', get breadcrumb() { return i18n.t('Teams.and.Members_'); } },
    { path: '/settings/integrations', get breadcrumb() { return i18n.t('Integrations_'); } },
    { path: '/settings/general', get breadcrumb() { return i18n.t('General_'); } },
    { path: RECORDING_EXTENSION_ROUTE, get breadcrumb() { return i18n.t('Browser.Extension_'); } },
    { path: '/settings/api-keys', get breadcrumb() { return i18n.t('Speech.to.text.api_'); } },
    { path: SETTINGS_ROUTE, get breadcrumb() { return i18n.t('Settings_'); } },
    { path: '/contacts/crm', get breadcrumb() { return i18n.t('Crm_'); } },
    { path: DEVICE_ROUTE, match: { url: '/settings' }, get breadcrumb() { return i18n.t('Settings_'); } },
    { path: DEVICE_ACTIVATE_ROUTE, get breadcrumb() { return i18n.t('Apps_'); } },
    { path: "/reseller", get breadcrumb() { return i18n.t('Reseller.invite_'); } },
    { path: "/reseller/invite", breadcrumb: null },
    { path: RESELLER_INVITE_ROUTE, breadcrumb: null },
    {
        path: "reseller-customers", get breadcrumb() { return i18n.t('My.customers_'); },
        children: [
            { path: "/reseller-customers/", get breadcrumb() { return i18n.t('My.customers_'); } },
            { path: "billing-history", get breadcrumb() { return i18n.t('Billing.history_'); } },
            { path: ":resellerCustomerId", breadcrumb: DynamicResellerCustomerBreadcrumb },
            {
                path: "settings", get breadcrumb() { return i18n.t('Settings_'); },
                children: [
                    { path: "guide", get breadcrumb() { return i18n.t('Guide_'); } },
                    { path: "guide-3cx", get breadcrumb() { return i18n.t('Guide.-.3CX_'); } }
                ]
            }
        ],
    },
];
